import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Laptop = function Laptop(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M19.642 17.012h-6.884c-.042 0-.063.042-.063.063v.274a.324.324 0 01-.316.315h-2.99a.324.324 0 01-.315-.315v-.253c0-.042-.042-.063-.063-.063H2.105c-.063 0-.105.042-.105.105v1.137c0 .547.442.99.99.99h15.789c.547 0 .99-.443.99-.99v-1.137c-.022-.063-.064-.126-.127-.126zM4.231 16.19h13.284a.854.854 0 00.864-.862v-3.432a7.972 7.972 0 01-1.727.274v2.295H5.094V7.033c0-.105.085-.168.169-.168h4.59a1.288 1.288 0 01-.443-.99c0-.274.084-.547.232-.758h-4.38a1.914 1.914 0 00-1.894 1.895v8.295c0 .505.38.884.863.884z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.19 8.715c-.316 0-.632-.042-.948-.147l-2.905-.863v2.063a.79.79 0 00.568.758l1.242.358c1.369.4 2.8.4 4.169 0l1.242-.358a.79.79 0 00.568-.758V7.684l-2.99.884a2.965 2.965 0 01-.947.147z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.747 6.21a.35.35 0 000-.673l-4.82-1.432A2.966 2.966 0 0016.188 4c-.252 0-.505.042-.736.105l-4.821 1.432a.35.35 0 000 .674l4.82 1.431c.232.063.485.105.737.105.253 0 .506-.042.737-.105L21.074 6.4v1.684h-.064a.144.144 0 00-.147.148v.779c0 .084.063.147.148.147h.042l-.253.484c-.042.105.021.21.126.21h.758c.105 0 .19-.126.127-.21l-.253-.484h.02a.144.144 0 00.148-.147v-.758a.144.144 0 00-.147-.148h-.063V6.274l.231-.063z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default Laptop;